var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brakes 1",
    clipPath: "url(#clip0_3872_13277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.453 8.4999H15.476C15.3514 6.42536 14.471 4.46836 13.0013 2.99888C11.5317 1.5294 9.57456 0.649282 7.5 0.524902V4.5509C8.50864 4.66442 9.44891 5.11686 10.167 5.83421C10.8851 6.55157 11.3385 7.49138 11.453 8.4999Z",
    stroke: "#797B80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.99995 2.81396C3.94143 3.15686 2.98865 3.76573 2.23284 4.5823C1.47702 5.39886 0.943475 6.39578 0.683278 7.4776C0.423081 8.55942 0.444946 9.68993 0.746781 10.7609C1.04862 11.8318 1.62031 12.8074 2.40714 13.5941C3.19396 14.3808 4.16957 14.9524 5.24056 15.2541C6.31155 15.5558 7.44205 15.5775 8.52384 15.3172C9.60563 15.0569 10.6025 14.5232 11.419 13.7673C12.2354 13.0114 12.8442 12.0585 13.187 11",
    stroke: "#797B80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 10.5C7.82843 10.5 8.5 9.82843 8.5 9C8.5 8.17157 7.82843 7.5 7 7.5C6.17157 7.5 5.5 8.17157 5.5 9C5.5 9.82843 6.17157 10.5 7 10.5Z",
    stroke: "#797B80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3872_13277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisklogo);
export default __webpack_public_path__ + "static/media/Disklogo.5df25f6e0a1dc36a985244cf19999936.svg";
export { ForwardRef as ReactComponent };